import styled from 'styled-components';
import { colors } from '../../styles/variables';

const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  background-color: transparent;
  font-size: 16px;
  padding: 4px 16px;
  border: 1px solid ${colors.gray300};
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  &::placeholder {
    color: ${colors.gray500};
  }
`;

const StyledIcon = styled.i`
  display: inline;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.gray600};
`

export const Select = ({id, name, options, ...props }) => {
  return (
    <div style={{ position: 'relative' }}>
      <StyledSelect name={name} id={id} {...props}>
        {options.map((option) => {
          const { id, value, label } = option;
          return (
            <option key={id} value={value}>
              {label}
            </option>
          );
        })}
      </StyledSelect>
      <StyledIcon
        className='fas fa-chevron-down'
      ></StyledIcon>
    </div>
  );
};
